import { useEffect, useState } from "react";

/** True once `active` has stayed true for `ms`. */
export function useHasWaited(ms: number, active: boolean): boolean {
  const [waited, setWaited] = useState(false);

  useEffect(() => {
    setWaited(false);
    if (!active) {
      return;
    }
    const timeout = window.setTimeout(() => setWaited(true), ms);
    return () => window.clearTimeout(timeout);
  }, [ms, active]);

  return waited;
}
